import React from 'react';
import { useId } from 'react-id-generator';

import { ToggleSliderWrapper } from './ToggleSlider.styles';

type ToggleSliderProps = {
  disabled?: boolean;
  value: boolean;
  onChange: (isChecked: boolean) => void;
};

export const ToggleSlider: React.FC<ToggleSliderProps> = ({ disabled, value, onChange }) => {
  const [id] = useId();
  return (
    <ToggleSliderWrapper>
      <input
        type="checkbox"
        id={id}
        checked={value}
        onChange={({ target }) => onChange(target.checked)}
        disabled={disabled}
      />
      <label htmlFor={id} className="toggle">
        <span className="toggle-handle" />
      </label>
    </ToggleSliderWrapper>
  );
};
